import i18n from '@/i18n'

export const msg = (name, isI18n = true) => i18n.t('required', { name: isI18n ? i18n.t(name) : name })

export default {
  productActive: [
    { required: true, message: msg('publicConsultation.form.product') }
  ],
  companyName: [
    { required: true, message: msg('publicConsultation.form.companyName') }
  ],
  contactPersonName: [
    { required: true, message: msg('publicConsultation.form.contactPersonName') }
  ],
  contactPersonPhone: [
    { required: true, message: msg('publicConsultation.form.contactPersonPhone') }
  ],
  descriptionOfNeeds: [
    { required: true, message: msg('publicConsultation.form.descriptionOfNeeds') }
  ]
}
